import React from 'react';

const BADGE = 'inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap';

export const InvoiceRemindersPausedBadge: React.FC = () => (
  <span className={`${BADGE} bg-amber-100 text-amber-800`}>Paused</span>
);
